import type { RouteDefinition } from "../../routes/routes";
import DSPDashboard from "./DSPDashboard";
import DSPLineItemDetails from "./DSPLineItemDetails";
import DSPOrderDetails from "./DSPOrderDetails";
import DSPAdvertisers from "./DSPAdvertisers";

export const DSPRoutes: RouteDefinition[] = [
  {
    path: "/dsp",
    layout: "/user",
    component: DSPAdvertisers,
    application: "Advertising",
    exact: true,
  },
  {
    path: "/dsp/:dspAdvertiser/dashboard",
    layout: "/user",
    component: DSPDashboard,
    application: "Advertising",
    exact: true,
  },
  {
    path: "/dsp/:dspAdvertiser/orders/:id",
    layout: "/user",
    component: DSPOrderDetails,
    application: "Advertising",
    exact: true,
  },
  {
    path: "/dsp/:dspAdvertiser/lineitems/:id",
    layout: "/user",
    component: DSPLineItemDetails,
    application: "Advertising",
    exact: true,
  },
];
